import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-28ed06b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "email-setting" }
const _hoisted_2 = { class: "email-setting__block" }
const _hoisted_3 = { class: "email-setting__head" }
const _hoisted_4 = { class: "email-setting__desc" }
const _hoisted_5 = { class: "setting-form" }
const _hoisted_6 = { class: "setting-form__subtitle" }
const _hoisted_7 = { class: "sender-email" }
const _hoisted_8 = { class: "auth-panel" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("SMTP")
const _hoisted_10 = {
  key: 0,
  class: "auth-box"
}
const _hoisted_11 = { class: "auth-box__text" }
const _hoisted_12 = {
  key: 0,
  class: "verified-box"
}
const _hoisted_13 = {
  key: 1,
  class: "auth-notice"
}
const _hoisted_14 = { class: "auth-actions" }
const _hoisted_15 = {
  key: 1,
  class: "auth-box"
}
const _hoisted_16 = { class: "auth-box__text" }
const _hoisted_17 = { class: "domain-auth__tip" }
const _hoisted_18 = {
  key: 0,
  class: "verified-box"
}
const _hoisted_19 = {
  key: 1,
  class: "auth-notice"
}
const _hoisted_20 = { class: "auth-actions" }
const _hoisted_21 = {
  key: 2,
  class: "dns-records"
}
const _hoisted_22 = { class: "dns-records__head" }
const _hoisted_23 = { class: "dns-records__cell" }
const _hoisted_24 = { class: "dns-records__cell" }
const _hoisted_25 = { class: "switch-text" }
const _hoisted_26 = { class: "save-area" }
const _hoisted_27 = {
  key: 0,
  class: "email-setting__block template-block"
}
const _hoisted_28 = { class: "email-setting__head" }
const _hoisted_29 = { class: "email-setting__title" }
const _hoisted_30 = { class: "email-setting__desc" }
const _hoisted_31 = { class: "template-list" }
const _hoisted_32 = { class: "template-row__intro" }
const _hoisted_33 = { class: "template-row__title" }
const _hoisted_34 = { class: "template-row__desc" }
const _hoisted_35 = { class: "template-row__control" }
const _hoisted_36 = { class: "template-row__label" }
const _hoisted_37 = { class: "template-select" }
const _hoisted_38 = { class: "rich-editor-wrap" }
const _hoisted_39 = { class: "variable-box" }
const _hoisted_40 = { class: "variable-box__title" }
const _hoisted_41 = { class: "drawer-footer" }
const _hoisted_42 = { class: "mail-preview-shell" }
const _hoisted_43 = { class: "mail-preview" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mail-preview__title" }, "メールプレビュー", -1))
const _hoisted_45 = { class: "mail-preview__content" }
const _hoisted_46 = { class: "mail-preview__subject" }
const _hoisted_47 = ["innerHTML"]
const _hoisted_48 = { class: "rich-editor-wrap rich-editor-wrap--small" }
const _hoisted_49 = { class: "drawer-footer" }

import { computed, onMounted, reactive, ref } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { CircleCheck, DocumentCopy, Message, View } from '@element-plus/icons-vue'
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css'
import { useStore } from 'vuex'
import { t } from '@/plugins/i18n'
import { request } from '@/config/request/interceptors'
import { copyText } from '@/plugins/utils'
import type {
  SesEmailAuthorizeRespDTO,
  ShopEmailAuthConfigRespDTO,
  ShopEmailDnsRecordRespDTO,
  ShopEmailSettingRespDTO,
  ShopEmailTemplatePreviewRespDTO,
  ShopEmailTemplateReqDTO,
  ShopEmailTemplateRespDTO
} from '@/service/customer'

/** 当前页面访问 Vuex 店铺状态的 store 实例。 */
interface DnsRecordItem {
  /** DNS 记录名称。 */
  name: string;
  /** DNS 记录类型。 */
  type: string;
  /** DNS 记录值。 */
  value: string;
}

/** 富文本编辑器可插入的模板变量。 */

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()

/** 页面展示的三种邮件发送场景。 */
const sceneOptions = [
  {
    value: 'NORMAL',
    title: '通常出荷メール',
    shortTitle: '通常出荷',
    desc: '注文商品のすべてが一度に出荷された際に送信されるメールです。'
  },
  {
    value: 'PARTIAL',
    title: '一部分納出荷メール',
    shortTitle: '一部分納出荷',
    desc: '注文商品の一部が出荷され、未出荷の商品が残っている際に送信されるメールです。'
  },
  {
    value: 'FINAL',
    title: '最終出荷メール',
    shortTitle: '最終出荷',
    desc: '残りの商品が出荷され、注文商品のすべての出荷が完了した際に送信されるメールです。'
  }
]

/** 邮件场景配置的快速索引。 */
const sceneMap = sceneOptions.reduce((cache, item) => {
  cache[item.value] = item
  return cache
}, {} as Record<string, typeof sceneOptions[number]>)

/** 认证方式枚举，统一页面和接口使用的值。 */
const AUTH_TYPE = {
  EMAIL: 'EMAIL',
  DOMAIN: 'DOMAIN'
} as const

/** DNS 列表单条记录结构。 */
const variableOptions = [
  { label: '顧客名', value: '{{customer_name}}' },
  { label: '注文(Shopify)', value: '{{order_no}}' },
  { label: '店舖名(名前)', value: '{{shop_name}}' },
  // { label: 'SKU', value: '{{sku}}' },
  // { label: '商品コード', value: '{{item_code}}' },
  // { label: '商品名', value: '{{item_name}}' },
  // { label: '個数', value: '{{item_quantity}}' },
  {
    label: '出荷商品明細', value: `{{#items}}
商品コード ...{{sku}}
商品規格...{{item_attribute}}
商品名 ... {{item_name}}
セット子商品名 ... {{item_sub_name}}
個数 ... {{item_quantity}}

{{/items}}`
  },
  { label: '配送業者', value: '{{carrier}}' },
  { label: 'お問い合わせ番号', value: '{{tracking_no}}' },
  {
    label: '追跡URL', value: `佐川急便：{{sagawa_tracking_url}}
ヤマト運輸：{{yamato_tracking_url}}`
  }
  // { label: '商品規格', value: '{{item_attribute}}' }
]

/** Quill 富文本编辑器工具栏配置。 */
const toolbarOptions = [
  [{ header: [1, 2, false] }],
  ['bold', 'italic', 'underline'],
  [{ color: [] }],
  [{ list: 'ordered' }, { list: 'bullet' }],
  ['link'],
  ['clean']
]

/** 创建邮件设置表单的默认状态。 */
const createDefaultForm = () => ({
  senderName: '',
  senderEmail: '',
  authType: AUTH_TYPE.EMAIL,
  verifiedSenderEmail: '',
  pendingSenderEmail: '',
  senderEmailEditing: false,
  autoSend: true,
  defaultTemplateIds: {
    NORMAL: '',
    PARTIAL: '',
    FINAL: ''
  },
  templateList: [] as ShopEmailTemplateRespDTO[]
})

/** 页面初始化加载状态。 */
const initLoading = ref(false)
/** 保存设置按钮 loading 状态。 */
const submitLoading = ref(false)
/** 授权相关按钮 loading 状态。 */
const authSendingLoading = ref(false)
/** 测试发送模板预览接口 loading 状态。 */
const testPreviewLoading = ref(false)
/** 测试发送接口 loading 状态。 */
const testSendLoading = ref(false)
/** 测试发送模板预览接口请求序号，用于避免旧响应覆盖新模板。 */
const testPreviewRequestSeq = ref(0)
/** 模板详情接口 loading 状态。 */
const templateDetailLoading = ref(false)
/** 编辑模板预览接口 loading 状态。 */
const templatePreviewLoading = ref(false)
/** 模板编辑侧边栏显示状态。 */
const templateDrawerVisible = ref(false)
/** 模板正文 Quill 编辑器实例引用。 */
const templateEditorRef = ref()
/** 编辑模板预览弹窗显示状态。 */
const templatePreviewVisible = ref(false)
/** 测试发送侧边栏显示状态。 */
const testDialogVisible = ref(false)
/** 当前正在编辑的模板 ID。 */
const editingTemplateId = ref('')
/** 邮件配信设置主表单。 */
const form = reactive(createDefaultForm())
/** 邮件授权配置详情，统一保存 `setting/detail` 接口的最新响应。 */
const emailConfig = ref<ShopEmailSettingRespDTO>()
/** 域名认证接口返回的 DNS 记录列表。 */
const domainDnsRecordList = ref<DnsRecordItem[]>([])
/** 模板编辑表单数据。 */
const templateForm = reactive<ShopEmailTemplateRespDTO>({})
/** 编辑模板预览弹窗数据。 */
const templatePreviewData = reactive({ subject: '', previewContent: '' })
/** 测试发送表单数据。 */
const testForm = reactive({
  to: '',
  templateId: '',
  subject: '',
  body: ''
})

/** 判断当前发件邮箱是否已经认证通过。 */
const isVerifiedSender = computed(() => Boolean(form.senderEmail && form.senderEmail === form.verifiedSenderEmail))
/** 判断是否展示测试发送按钮。 */
const showTestSend = computed(() => Boolean(form.senderEmail))
/** 判断是否展示发送认证邮件按钮。 */
const showSendAuth = computed(() => Boolean(form.senderEmail && form.senderEmail !== form.verifiedSenderEmail))
/** 判断 SMTP 认证按钮是否可点击。 */
const canStartSmtpAuth = computed(() => Boolean(form.senderName?.trim() && form.senderEmail && form.authType === AUTH_TYPE.EMAIL))
/** 判断域名认证按钮是否可点击。 */
const canStartDomainAuth = computed(() => Boolean(form.senderName?.trim() && form.senderEmail && form.authType === AUTH_TYPE.DOMAIN))
/** 判断是否展示域名认证的「取得」按钮。 */
const showStartDomainAuth = computed(() => {
  /** 当前已生效的域名认证邮箱。 */
  const currentActiveDomainEmail = activeDomainAuthEmail.value
  /** 当前是否存在待认证中的域名邮箱。 */
  const hasPendingDomainEmail = Boolean(getAuthorizingDomainEmail(emailConfig.value))
  if (form.authType !== AUTH_TYPE.DOMAIN) return false
  if (!hasPendingDomainEmail && form.senderEmail && currentActiveDomainEmail && form.senderEmail === currentActiveDomainEmail) return false
  return true
})
/** 判断发件邮箱输入框是否应锁定编辑。 */
const senderEmailDisabled = computed(() => Boolean(form.verifiedSenderEmail && !form.senderEmailEditing))
/** 判断是否展示更换邮箱后的重新认证提示。 */
const showReAuthNotice = computed(() => Boolean(form.verifiedSenderEmail && form.senderEmail && form.senderEmail !== form.verifiedSenderEmail))
/** 当前 tab 对应的统一授权状态。0 未认证、1 认证中、2 已认证、3 认证失败。 */
const normalizedAuthStatus = computed(() => getAuthorizationState(emailConfig.value, form.authType).authStatus)
/** 当前生效的域名邮箱。 */
const activeDomainAuthEmail = computed(() => getActiveDomainAuthEmail(emailConfig.value))
/** 当前生效的邮箱认证邮箱。 */
const activeEmailAuthEmail = computed(() => getActiveEmailAuthEmail(emailConfig.value))
/** 域名认证区域的提示信息。 */
const domainAuthMessage = computed(() => {
  if (normalizedAuthStatus.value === 3) return t('DNS設定をご確認のうえ、再度取得してください。')
  if (domainDnsRecordList.value.length) return t('取得したDNSレコードをサーバー設定担当者へ共有してください。')
  return ''
})
/** 根据发件邮箱认证状态生成展示文案。 */
const authStatusText = computed(() => {
  if (isVerifiedSender.value) return t('認証済み')
  if (!form.senderEmail) return t('未認証')
  if (form.pendingSenderEmail === form.senderEmail && normalizedAuthStatus.value === 3) return t('認証に失敗しました')
  if (form.pendingSenderEmail === form.senderEmail && normalizedAuthStatus.value === 1) return t('認証中')
  return form.verifiedSenderEmail ? t('再認証が必要') : t('未認証')
})

/** 页面挂载后加载当前店铺的邮件配信设置。 */
onMounted(async () => {
  await refreshPendingAuthorization()
  await loadSettings()
})

/** 深拷贝模板数据，避免抽屉编辑时直接污染原始模板。 */
function cloneTemplateData<T>(value: T): T {
  return JSON.parse(JSON.stringify(value)) as T
}

/** 当前正在配置的客户店铺 ID。 */
const customerShopId = computed(() => store.getters.curShop || store.getters.shopInfo?.customerShopId)

/** 生成邮件设置接口统一需要的店铺参数。 */
function getShopPayload() {
  return {
    customerShopId: Number(customerShopId.value)
  }
}

/** 从邮箱中提取域名，供域名认证直接使用。 */
function getDomainFromEmail(email?: string) {
  return String(email || '').split('@')[1] || ''
}

/** 解析设置详情里的 `authConfigJson`，兼容对象和历史字符串结构。 */
function parseAuthConfigJson(data?: ShopEmailSettingRespDTO): ShopEmailAuthConfigRespDTO {
  if (!data?.authConfigJson) return {}
  try {
    return typeof data.authConfigJson === 'string'
      ? JSON.parse(data.authConfigJson) as ShopEmailAuthConfigRespDTO
      : data.authConfigJson
  } catch (error) {
    return {}
  }
}

/** 获取设置详情里的认证配置对象。 */
function getAuthConfig(data?: ShopEmailSettingRespDTO) {
  return parseAuthConfigJson(data)
}

/** 从设置详情中读取待认证域名，兼容平铺字段和 `authConfigJson`。 */
function getAuthorizingDomain(data?: ShopEmailSettingRespDTO) {
  return data?.authorizingDomain || getAuthConfig(data).authorizingDomain || ''
}

/** 从设置详情或 `authConfigJson` 中安全读取兼容字段。 */
function getAuthConfigField<T = unknown>(data: ShopEmailSettingRespDTO | undefined, fieldName: string) {
  /** 平铺结构里的字段值。 */
  const rootValue = data ? Reflect.get(data as Record<string, unknown>, fieldName) : undefined
  if (rootValue !== undefined && rootValue !== null && rootValue !== '') return rootValue as T
  /** `authConfigJson` 里的同名字段值。 */
  const authConfigValue = Reflect.get(getAuthConfig(data) as Record<string, unknown>, fieldName)
  return authConfigValue as T
}

/** 从设置详情中读取授权中的域名邮箱。 */
function getAuthorizingDomainEmail(data?: ShopEmailSettingRespDTO) {
  return String(getAuthConfigField(data, 'authorizingDomainEmail') || '')
}

/** 从设置详情中读取当前生效的域名邮箱，兼容新旧字段。 */
function getActiveDomainAuthEmail(data?: ShopEmailSettingRespDTO) {
  /** 新接口单独返回的当前生效域名邮箱。 */
  const activeDomainEmail = String(getAuthConfigField(data, 'activeDomainAuthEmail') || '')
  if (activeDomainEmail) return activeDomainEmail
  return data?.identityType === AUTH_TYPE.DOMAIN ? String(data?.senderEmail || '') : ''
}

/** 从设置详情中读取当前生效的邮箱认证邮箱，兼容新旧字段。 */
function getActiveEmailAuthEmail(data?: ShopEmailSettingRespDTO) {
  /** 新接口单独返回的当前生效 SMTP 邮箱。 */
  const activeEmail = String(getAuthConfigField(data, 'activeEmailAuthEmail') || '')
  if (activeEmail) return activeEmail
  return data?.identityType === AUTH_TYPE.EMAIL ? String(data?.senderEmail || '') : ''
}

/** 从设置详情中读取待认证域名状态，兼容平铺字段和 `authConfigJson`。 */
function getAuthorizingDomainStatus(data?: ShopEmailSettingRespDTO) {
  if (typeof data?.authorizingDomainStatus === 'number') {
    return data.authorizingDomainStatus
  }
  return getAuthConfig(data).authorizingDomainStatus
}

/** 从设置详情中读取邮箱认证状态，兼容平铺字段和历史字段。 */
function getAuthorizingEmailStatus(data?: ShopEmailSettingRespDTO) {
  if (typeof data?.authorizingEmailStatus === 'number') {
    return data.authorizingEmailStatus
  }
  if (typeof getAuthConfig(data).authorizingEmailStatus === 'number') {
    return getAuthConfig(data).authorizingEmailStatus
  }
  return data?.verifyingStatus
}

/** 判断当前是否存在“待授权”的域名认证。 */
function isPendingDomainAuthorization(data?: ShopEmailSettingRespDTO) {
  return Boolean(getAuthorizingDomain(data) && getAuthorizingDomainStatus(data) !== 1)
}

/** 将接口返回的 DNS 记录数组转换成页面渲染结构。 */
function mapDnsRecordList(dnsRecords?: ShopEmailDnsRecordRespDTO[]) {
  return Array.isArray(dnsRecords)
    ? dnsRecords.map((item) => ({
      name: String(item?.name || ''),
      type: String(item?.type || ''),
      value: String(item?.value || '')
    }))
    : []
}

/** 从设置详情中提取用于页面回显的 DNS 记录列表，优先使用最新接口对象结构。 */
function getDnsRecordListFromSettingDetail(data?: ShopEmailSettingRespDTO) {
  if (!isPendingDomainAuthorization(data)) return []
  const authConfig = getAuthConfig(data)
  if (Array.isArray(authConfig.dnsRecords)) {
    return mapDnsRecordList(authConfig.dnsRecords)
  }
  return parseDnsRecords(authConfig.dnsRecords as unknown as string)
}

/** 拉取邮件配信设置详情，并合并到页面表单状态。 */
async function loadSettings() {
  initLoading.value = true
  try {
    /** 邮件配信设置详情接口响应。 */
    const res = await request.customer.aws.shopEmailSettingDetail(getShopPayload())
    /** 邮件配信设置详情数据。 */
    const data = res?.data
    emailConfig.value = data
    domainDnsRecordList.value = getDnsRecordListFromSettingDetail(data)
    Object.assign(form, createDefaultForm(), mapSettingDetail(data))
  } catch (error) {
    domainDnsRecordList.value = []
    Object.assign(form, createDefaultForm())
  } finally {
    initLoading.value = false
  }
}

/** 页面进入时先刷新一次认证中的 AWS 邮件身份状态。 */
async function refreshPendingAuthorization() {
  try {
    await request.customer.aws.shopEmailAuthorizationPendingRefresh(getShopPayload())
  } catch (error) {
    // 刷新认证中状态失败时不阻断详情加载，页面继续使用详情接口兜底展示。
  }
}

/** 统一读取设置详情中的认证中邮箱，兼容新旧字段。 */
function getAuthorizingEmail(data?: ShopEmailSettingRespDTO) {
  return String(getAuthConfigField(data, 'authorizingEmail') || '')
}

/** 将接口里的待验证状态码转换为页面通用状态。 */
function mapPendingStatusToNormalizedStatus(status?: number) {
  if (status === 1) return 2
  if (status === 2) return 3
  return 1
}

/** 根据当前 tab 使用的邮箱和状态，统一生成页面授权状态码。 */
function resolveAuthorizationStatus(activeEmail: string, pendingEmail: string, pendingStatus?: number) {
  if (pendingEmail) {
    return typeof pendingStatus === 'number'
      ? mapPendingStatusToNormalizedStatus(pendingStatus)
      : 1
  }
  if (activeEmail) return 2
  return 0
}

/** 将 `authorization/send` 的状态码统一映射为页面使用的授权状态码。 */
function mapSendVerificationStatusToAuthStatus(status?: number) {
  if (status === 1) return 2
  if (status === 2) return 3
  return 1
}

/** 将邮件授权相关字段抽成统一结构，便于页面和接口之间复用。 */
function getAuthorizationState(data?: ShopEmailSettingRespDTO, authType = AUTH_TYPE.EMAIL) {
  /** 当前选中的认证方式。 */
  const currentAuthType = authType === AUTH_TYPE.DOMAIN ? AUTH_TYPE.DOMAIN : AUTH_TYPE.EMAIL
  /** 当前 tab 的生效邮箱。 */
  const activeSenderEmail = currentAuthType === AUTH_TYPE.DOMAIN
    ? getActiveDomainAuthEmail(data)
    : getActiveEmailAuthEmail(data)
  /** 当前 tab 的待认证邮箱。 */
  const authorizingSenderEmail = currentAuthType === AUTH_TYPE.DOMAIN
    ? getAuthorizingDomainEmail(data)
    : getAuthorizingEmail(data)
  /** 当前 tab 的认证状态。 */
  const authStatus = currentAuthType === AUTH_TYPE.DOMAIN
    ? resolveAuthorizationStatus(activeSenderEmail, authorizingSenderEmail, getAuthorizingDomainStatus(data))
    : resolveAuthorizationStatus(activeSenderEmail, authorizingSenderEmail, getAuthorizingEmailStatus(data))
  /** 当前页面优先展示的发件邮箱，认证中邮箱优先于当前生效邮箱。 */
  const senderEmail = authorizingSenderEmail || activeSenderEmail || data?.senderEmail || ''
  /** 当前已认证且生效的发件邮箱。 */
  const verifiedSenderEmail = activeSenderEmail
  /** 当前待认证中的发件邮箱。 */
  const pendingSenderEmail = authStatus === 1 || authStatus === 3 ? authorizingSenderEmail : ''

  return {
    authStatus,
    senderEmail,
    verifiedSenderEmail,
    pendingSenderEmail
  }
}

/** 获取当前认证方式下允许保存的邮箱列表。 */
function getAllowedSenderEmailsByAuthType(data?: ShopEmailSettingRespDTO, authType = form.authType) {
  /** 当前认证方式对应的生效邮箱。 */
  const activeSenderEmail = authType === AUTH_TYPE.DOMAIN
    ? getActiveDomainAuthEmail(data)
    : getActiveEmailAuthEmail(data)
  /** 当前认证方式对应的认证中邮箱。 */
  const authorizingSenderEmail = authType === AUTH_TYPE.DOMAIN
    ? getAuthorizingDomainEmail(data)
    : getAuthorizingEmail(data)

  return [authorizingSenderEmail, activeSenderEmail].filter(Boolean)
}

/** 只同步授权相关字段，避免覆盖用户尚未保存的其他表单输入。 */
function syncAuthorizationFormState(data?: ShopEmailSettingRespDTO, syncSenderEmail = false, authType = form.authType) {
  /** 从设置详情中抽取后的授权状态。 */
  const authorizationState = getAuthorizationState(data, authType)

  if (syncSenderEmail) {
    form.senderEmail = authorizationState.senderEmail
  }
  form.verifiedSenderEmail = authorizationState.verifiedSenderEmail
  form.pendingSenderEmail = authorizationState.pendingSenderEmail
  form.senderEmailEditing = !authorizationState.verifiedSenderEmail || Boolean(authorizationState.pendingSenderEmail)
}

/** 发起授权后刷新设置详情中的授权状态，失败时交由本地兜底状态维持页面展示。 */
async function refreshAuthorizationState() {
  /** 邮件授权详情接口响应。 */
  const res = await request.customer.aws.shopEmailSettingDetail(getShopPayload())
  if (!res?.success) return false
  emailConfig.value = res.data
  domainDnsRecordList.value = getDnsRecordListFromSettingDetail(res.data)
  syncAuthorizationFormState(res.data, true, form.authType)
  return true
}

/** 将设置详情接口返回值转换成页面表单结构。 */
function mapSettingDetail(data?: ShopEmailSettingRespDTO) {
  /** 统一提取后的授权状态。 */
  const authType = data?.identityType === AUTH_TYPE.DOMAIN ? AUTH_TYPE.DOMAIN : AUTH_TYPE.EMAIL
  /** 当前生效认证方式下的授权状态。 */
  const authorizationState = getAuthorizationState(data, authType)
  /** 接口返回的模板列表。 */
  const templateList = Array.isArray(data?.templateList) ? data.templateList.map(mapApiTemplate) : []
  /** 三种邮件场景当前默认模板 ID。 */
  const defaultTemplateIds = normalizeDefaultTemplateIds({
    NORMAL: stringifyId(data?.normalTemplateId),
    PARTIAL: stringifyId(data?.partialTemplateId),
    FINAL: stringifyId(data?.finalTemplateId)
  }, templateList)

  return {
    senderName: data?.senderName || '',
    senderEmail: authorizationState.senderEmail,
    authType,
    verifiedSenderEmail: authorizationState.verifiedSenderEmail,
    pendingSenderEmail: authorizationState.pendingSenderEmail,
    senderEmailEditing: !authorizationState.verifiedSenderEmail || Boolean(authorizationState.pendingSenderEmail),
    autoSend: data?.emailAutoSendEnabled === 1,
    defaultTemplateIds,
    templateList
  }
}

/** `authorization/send` 成功后在本地合成一份授权状态，作为 `setting/detail` 刷新失败时的兜底。 */
function applyAuthorizationSendResult(data?: SesEmailAuthorizeRespDTO) {
  /** 当前认证接口返回的目标邮箱。 */
  const authorizedEmail = data?.authorizedEmail || form.senderEmail
  /** 当前认证接口返回的目标域名。 */
  const domainName = data?.domainName || getAuthorizingDomain(emailConfig.value) || getDomainFromEmail(form.senderEmail)
  /** 统一映射后的授权状态码。 */
  const authStatus = mapSendVerificationStatusToAuthStatus(data?.verificationStatus)
  /** 当前目标邮箱是否已经认证成功。 */
  const authorized = authStatus === 2
  /** 当前页面保留的授权配置。 */
  const currentConfig = emailConfig.value || {}
  /** 本地兜底使用的最新授权配置。 */
  const nextConfig = {
    ...currentConfig,
    authorized: authorized || Boolean(currentConfig.authorized),
    identityType: data?.identityType || (form.authType === AUTH_TYPE.DOMAIN ? AUTH_TYPE.DOMAIN : currentConfig.identityType),
    senderEmail: currentConfig.senderEmail,
    authorizingDomain: form.authType === AUTH_TYPE.DOMAIN ? domainName : currentConfig.authorizingDomain,
    authorizingDomainEmail: form.authType === AUTH_TYPE.DOMAIN ? (authorized ? '' : authorizedEmail) : currentConfig.authorizingDomainEmail,
    authorizingDomainStatus: form.authType === AUTH_TYPE.DOMAIN ? (authorized ? 1 : authStatus === 3 ? 2 : 0) : currentConfig.authorizingDomainStatus,
    authorizingEmail: form.authType === AUTH_TYPE.EMAIL ? (authorized ? '' : authorizedEmail) : currentConfig.authorizingEmail,
    authorizingType: data?.identityType || (form.authType === AUTH_TYPE.DOMAIN ? AUTH_TYPE.DOMAIN : currentConfig.authorizingType),
    authorizingStatus: form.authType === AUTH_TYPE.EMAIL ? (authorized ? 1 : authStatus === 3 ? 2 : 0) : currentConfig.authorizingStatus,
    authorizingEmailStatus: form.authType === AUTH_TYPE.EMAIL ? (authorized ? 1 : authStatus === 3 ? 2 : 0) : currentConfig.authorizingEmailStatus,
    authStatus
  } as ShopEmailSettingRespDTO & Record<string, unknown>

  if (form.authType === AUTH_TYPE.EMAIL && authorized) {
    nextConfig.senderEmail = authorizedEmail
    nextConfig.activeEmailAuthEmail = authorizedEmail
  }
  if (form.authType === AUTH_TYPE.DOMAIN && authorized) {
    nextConfig.senderEmail = authorizedEmail
    nextConfig.activeDomainAuthEmail = authorizedEmail
  }
  emailConfig.value = nextConfig
  syncAuthorizationFormState(emailConfig.value, true, form.authType)
}

/** 解析接口返回的 DNS JSON 字符串，转换成列表结构供页面渲染。 */
function parseDnsRecords(dnsRecords?: string | ShopEmailDnsRecordRespDTO[]) {
  if (!dnsRecords) return []
  if (Array.isArray(dnsRecords)) {
    return mapDnsRecordList(dnsRecords)
  }
  try {
    /** 当前待解析的 DNS 原始值，兼容被字符串包裹的 JSON 字符串。 */
    let parsedValue: any = dnsRecords
    /** 最多尝试两次 JSON 解析，兼容 `authConfigJson` 内部再次包裹字符串的情况。 */
    for (let index = 0; index < 2 && typeof parsedValue === 'string'; index++) {
      parsedValue = JSON.parse(parsedValue)
    }
    /** 解析后的原始 DNS 列表。 */
    const recordList = parsedValue
    return mapDnsRecordList(recordList)
  } catch (error) {
    return []
  }
}

/** 复制 DNS 记录中的名称或值，复用系统统一复制提示。 */
function copyDnsField(value: string) {
  copyText(value)
}

/** 将后端模板对象转换成页面使用的模板对象。 */
function mapApiTemplate(template: ShopEmailTemplateRespDTO): ShopEmailTemplateRespDTO {
  return {
    ...template,
    id: template.id,
    templateName: template.templateName || `${getTemplateSceneTitle(template.templateScene)}メール`,
    templateScene: template.templateScene || 'NORMAL',
    subject: template?.subject || '',
    content: ensureHtml(template?.content || ''),
    isDefault: template?.isDefault || 0
  }
}

/** 校准每个邮件场景当前选中的默认模板 ID。 */
function normalizeDefaultTemplateIds(defaultIds: ReturnType<typeof createDefaultForm>['defaultTemplateIds'], templateList: ShopEmailTemplateRespDTO[]) {
  return sceneOptions.reduce((cache, scene) => {
    /** 当前场景接口指定的默认模板 ID。 */
    const selected = defaultIds[scene.value]
    /** 当前场景中仍然有效的已选模板。 */
    const validSelected = templateList.find(item => stringifyId(item.id) === selected && item.templateScene === scene.value)
    /** 当前场景没有有效选择时使用的兜底模板。 */
    const fallback = templateList.find(item => item.templateScene === scene.value && item.isDefault === 1) ||
      templateList.find(item => item.templateScene === scene.value)
    cache[scene.value] = stringifyId(validSelected?.id || fallback?.id)
    return cache
  }, {} as ReturnType<typeof createDefaultForm>['defaultTemplateIds'])
}

/** 获取指定邮件场景下拉展示的唯一模板选项。 */
function templatesByScene(scene: string) {
  /** 下拉选项只展示一个和当前场景对应的模板。 */
  const currentTemplate = getTemplateByScene(scene)
  return currentTemplate ? [currentTemplate] : []
}

/** 获取指定邮件场景对应的唯一模板数据。 */
function getTemplateByScene(scene: string) {
  /** 当前场景已经选中的默认模板。 */
  const selectedTemplate = form.templateList.find(item => stringifyId(item.id) === form.defaultTemplateIds[scene] && item.templateScene === scene)
  /** 当前场景没有选中值时使用的第一条模板。 */
  const fallbackTemplate = form.templateList.find(item => item.templateScene === scene)
  return selectedTemplate || fallbackTemplate
}

/** 打开当前场景已选模板的查看编辑侧边栏。 */
async function openSelectedTemplate(scene: string) {
  /** 当前场景下拉选中的模板 ID。 */
  const templateId = form.defaultTemplateIds[scene] || stringifyId(templatesByScene(scene)[0]?.id)
  await openTemplateDrawer(templateId, scene)
}

/** 按模板 ID 打开模板查看编辑侧边栏。 */
async function openTemplateDrawer(templateId?: string, scene = 'NORMAL') {
  /** 当前要查看编辑的模板 ID。 */
  const currentTemplateId = templateId || stringifyId(getTemplateByScene(scene)?.id)
  if (!currentTemplateId) {
    ElMessage.warning(t('メールテンプレートがありません'))
    return
  }
  templateDetailLoading.value = true
  try {
    /** 模板详情接口响应。 */
    const res = await request.customer.aws.shopEmailTemplateDetail({
      ...getShopPayload(),
      id: numberId(currentTemplateId),
      templateScene: scene
    })
    if (!res?.success || !res?.data) {
      ElMessage.warning(t('メールテンプレートがありません'))
      return
    }
    /** 接口最新模板详情数据。 */
    const template = mapApiTemplate(res.data)
    syncTemplateListItem(template)
    Object.assign(templateForm, cloneTemplateData(template))
    editingTemplateId.value = stringifyId(template.id)
    templateDrawerVisible.value = true
  } finally {
    templateDetailLoading.value = false
  }
}

/** 将最新模板详情同步回页面模板列表。 */
function syncTemplateListItem(template: ShopEmailTemplateRespDTO) {
  /** 最新模板在本地列表中的位置。 */
  const index = form.templateList.findIndex(item => stringifyId(item.id) === stringifyId(template.id))
  if (index > -1) {
    form.templateList.splice(index, 1, template)
  } else {
    form.templateList.unshift(template)
  }
}

/** 切换模板场景时同步替换为对应场景模板的 ID 和内容信息。 */
function handleTemplateSceneChange(scene: string) {
  /** 目标场景对应的模板数据。 */
  const template = getTemplateByScene(scene)
  if (!template) {
    ElMessage.warning(t('メールテンプレートがありません'))
    templateForm.templateScene = scene
    return
  }
  Object.assign(templateForm, cloneTemplateData(template))
  editingTemplateId.value = stringifyId(template.id)
}
const confirmLoading = ref(false)
/** 保存当前模板到后端，并更新本地模板列表。 */
async function saveTemplate() {
  /** 校验并标准化后的模板编辑表单。 */
  const validTemplate = await getValidTemplateForm()
  if (!validTemplate) return
  confirmLoading.value = true
  /** 当前待保存的模板数据副本。 */
  const payload = cloneTemplateData({
    ...templateForm,
    ...validTemplate
  })

  if (!payload.id) {
    delete payload.id
  }
  /** 模板保存接口响应。 */
  const apiRes = await request.customer.aws.shopEmailTemplateSave({
    ...getShopPayload(),
    id: payload.id,
    templateName: payload.templateName,
    templateScene: payload.templateScene,
    subject: payload.subject,
    content: payload.content,
    isDefault: payload.isDefault ? 1 : 0
  })

  confirmLoading.value = false
  if (apiRes?.success && apiRes?.data?.id) {
    payload.id = apiRes.data.id
  }

  syncTemplateListItem(payload)
  if (payload.templateScene && (!form.defaultTemplateIds[payload.templateScene] || payload.isDefault)) {
    form.defaultTemplateIds[payload.templateScene] = stringifyId(payload.id)
  }
  form.defaultTemplateIds = normalizeDefaultTemplateIds(form.defaultTemplateIds, form.templateList)
  templateDrawerVisible.value = false
  ElMessage.success(t(editingTemplateId.value ? 'テンプレートを更新しました' : 'テンプレートを追加しました'))
}

/** 请求当前编辑模板的渲染预览并打开预览弹窗。 */
async function previewCurrentTemplate() {
  /** 校验并标准化后的模板编辑表单。 */
  const validTemplate = getValidTemplateForm()
  if (!validTemplate) return
  templatePreviewLoading.value = true
  try {
    /** 编辑模板预览接口响应。 */
    const res = await request.customer.aws.shopEmailTemplatePreview(buildTemplatePreviewPayload({
      templateScene: validTemplate.templateScene,
      subject: validTemplate.subject,
      content: validTemplate.content
    }))
    if (!res?.success) return
    templatePreviewData.subject = res.data?.subject || ''
    templatePreviewData.previewContent = getTemplatePreviewContent(res.data)
    templatePreviewVisible.value = true
  } finally {
    templatePreviewLoading.value = false
  }
}
const rules = ref({
  templateName: [
    {
      required: true,
      message: '※必須項目です',
      trigger: 'blur'
    }
  ],
  templateScene: [
    {
      required: true,
      message: '※必須項目です',
      trigger: 'blur'
    }
  ],
  subject: [
    {
      required: true,
      message: '※必須項目です',
      trigger: 'blur'
    }
  ],
  body: [
    {
      required: true,
      message: '※必須項目です',
      trigger: 'blur'
    }
  ],
  content: [
    {
      required: true,
      message: '※必須項目です',
      trigger: 'blur',
      validator: (rule: any, value: any, callback: any) => {
        if (!value || !getPlainText(value)) {
          callback(new Error('※必須項目です'))
          return
        }
        callback()
      }
    }
  ]
})
/** 测试发送抽屉表单校验规则。 */
const testRules = ref({
  to: [
    {
      required: true,
      message: '※必須項目です',
      trigger: 'blur'
    },
    {
      validator: (rule: any, value: string, callback: any) => {
        if (!value || !String(value).trim()) {
          callback(new Error('※必須項目です'))
          return
        }
        if (!isEmail(String(value).trim())) {
          callback(new Error(t('メールアドレスを入力してください')))
          return
        }
        callback()
      },
      trigger: 'blur'
    }
  ],
  templateId: [
    {
      required: true,
      message: '※必須項目です',
      trigger: 'change'
    }
  ],
  subject: [
    {
      required: true,
      message: '※必須項目です',
      trigger: 'blur'
    }
  ],
  body: [
    {
      required: true,
      message: '※必須項目です',
      trigger: 'blur',
      validator: (rule: any, value: string, callback: any) => {
        if (!value || !getPlainText(value)) {
          callback(new Error('※必須項目です'))
          return
        }
        callback()
      }
    }
  ]
})
const templateFormRef = ref()
/** 测试发送抽屉表单实例。 */
const testFormRef = ref()
/** 校验模板编辑抽屉所有必填项，并返回去除首尾空格后的值。 */
async function getValidTemplateForm() {
  /** 去除首尾空格后的模板名称。 */
  const templateName = templateForm.templateName?.trim()
  /** 当前模板场景。 */
  const templateScene = templateForm.templateScene?.trim()
  /** 去除首尾空格后的邮件主题。 */
  const subject = templateForm.subject?.trim()
  /** 去除首尾空格后的邮件正文 HTML。 */
  const content = templateForm.content?.trim()
  // if (!content || !getPlainText(content)) {
  //   ElMessage.error(t('【本文】必須項目です'))
  //   // return
  // }
  const res = await templateFormRef.value.validate()
  return {
    templateName,
    templateScene,
    subject,
    content
  }
}

/** 将变量占位符追加到模板正文末尾。 */
function insertVariable(value: string) {
  const editor = templateEditorRef.value
  const quill = editor?.getQuill?.() || editor?.getEditor?.() || editor?.quill
  if (!quill) {
    templateForm.content = appendVariable(templateForm.content || '', value)
    return
  }
  const range = quill.getSelection(true)
  const index = typeof range?.index === 'number' ? range.index : Math.max(quill.getLength() - 1, 0)
  quill.insertText(index, value)
  quill.setSelection(index + value.length, 0)
  quill.focus()
}

/** 处理发件邮箱输入变化，并重置不匹配的待认证邮箱。 */
function handleSenderEmailInput() {
  form.senderEmailEditing = true
  if (form.pendingSenderEmail !== form.senderEmail) {
    form.pendingSenderEmail = ''
  }
  if (form.authType === AUTH_TYPE.DOMAIN) {
    domainDnsRecordList.value = []
  }
}

/** 进入发件邮箱编辑状态。 */
function startSenderEmailEdit() {
  form.senderEmailEditing = true
  form.pendingSenderEmail = ''
}

/** 切换认证方式时清理不匹配的临时认证数据。 */
function handleAuthTypeChange() {
  if (emailConfig.value) {
    syncAuthorizationFormState(emailConfig.value, true, form.authType)
  }
  if (form.authType !== AUTH_TYPE.DOMAIN) {
    domainDnsRecordList.value = []
    return
  }
  domainDnsRecordList.value = getDnsRecordListFromSettingDetail(emailConfig.value)
}

/** 发送 SMTP 邮箱认证邮件。 */
async function startSmtpAuth() {
  if (authSendingLoading.value) return
  if (!isEmail(form.senderEmail)) {
    ElMessage.error(t('メールアドレスを入力してください'))
    return
  }
  try {
    authSendingLoading.value = true
    /** 发起邮箱授权接口响应。 */
    const res = await request.customer.aws.shopEmailAuthorizationSend({
      ...getShopPayload(),
      authorizedEmail: form.senderEmail,
      identityType: AUTH_TYPE.EMAIL
    })
    if (!res?.success) return

    applyAuthorizationSendResult(res.data)
    try {
      await refreshAuthorizationState()
    } catch (error) {
      // 设置详情刷新失败时，继续使用本地兜底状态，保证授权提示不丢失。
    }
    ElMessageBox.alert(
      t('ご入力いただいたメールアドレスに認証メールを送信しました。メールに記載されたURLをクリックし、認証を完了してください。'),
      t('認証メール送信完了'),
      { confirmButtonText: t('確認しました') }
    )
  } finally {
    authSendingLoading.value = false
  }
}

/** 获取域名认证需要的 DNS 列表，并展示给用户进行配置。 */
async function startDomainAuth() {
  if (authSendingLoading.value) return
  if (!isEmail(form.senderEmail)) {
    ElMessage.error(t('メールアドレスを入力してください'))
    return
  }
  /** 当前发件邮箱对应的域名。 */
  const domainName = getDomainFromEmail(form.senderEmail)
  if (!domainName) {
    ElMessage.error(t('ドメインを取得できるメールアドレスを入力してください'))
    return
  }
  try {
    authSendingLoading.value = true
    /** 发起域名认证接口响应。 */
    const res = await request.customer.aws.shopEmailAuthorizationSend({
      ...getShopPayload(),
      authorizedEmail: form.senderEmail,
      domainName,
      identityType: AUTH_TYPE.DOMAIN
    })
    if (!res?.success) return

    applyAuthorizationSendResult(res.data)
    try {
      await refreshAuthorizationState()
    } catch (error) {
      // 设置详情刷新失败时，继续使用本地兜底状态和 DNS 列表。
    }
  } finally {
    authSendingLoading.value = false
  }
}

/** 打开测试发送弹窗，并带入默认模板内容。 */
function openTestDialog() {
  /** 测试发送默认使用的模板 ID。 */
  const templateId = form.defaultTemplateIds.NORMAL || stringifyId(form.templateList[0]?.id)
  testForm.to = form.senderEmail || ''
  testForm.templateId = templateId
  testDialogVisible.value = true
  testFormRef.value?.clearValidate?.()
  syncTestTemplate()
}

/** 根据测试发送选择的模板请求预览接口并同步主题和正文内容。 */
async function syncTestTemplate() {
  /** 测试发送当前选择的模板。 */
  const template = form.templateList.find(item => stringifyId(item.id) === testForm.templateId) || form.templateList[0]
  if (!template) return
  /** 本次预览请求序号。 */
  const currentSeq = testPreviewRequestSeq.value + 1
  testPreviewRequestSeq.value = currentSeq
  testPreviewLoading.value = true
  try {
    /** 模板预览接口响应。 */
    const res = await request.customer.aws.shopEmailTemplatePreview(buildTemplatePreviewPayload({
      templateScene: template.templateScene || 'NORMAL',
      subject: template.subject || '',
      content: template.content || ''
    }))
    if (currentSeq !== testPreviewRequestSeq.value || !res?.success) return
    testForm.subject = res.data?.subject || ''
    testForm.body = getTemplatePreviewContent(res.data)
  } finally {
    if (currentSeq === testPreviewRequestSeq.value) {
      testPreviewLoading.value = false
    }
  }
}

/** 构造模板预览接口入参，除模板场景、主题和正文外其余数据保持固定。 */
function buildTemplatePreviewPayload(template: Pick<ShopEmailTemplateRespDTO, 'templateScene' | 'subject' | 'content'>): ShopEmailTemplateReqDTO {
  /** 当前预览模板场景。 */
  const templateScene = template.templateScene || 'NORMAL'
  /** 当前预览邮件主题。 */
  const subject = template.subject || ''
  /** 当前预览邮件正文。 */
  const content = template.content || ''
  /** 模板预览接口固定入参。 */
  const payload: ShopEmailTemplateReqDTO = {
    templateScene,
    subject,
    content,
    variableMap: {
      customer_name: 'キハラ チトセ',
      shopify_order_name: '#1870',
      carrier: '佐川急便',
      tracking_no: '365966410574',
      sagawa_tracking_url: 'https://k2k.sagawa-exp.co.jp/p/sagawa/web/okurijoinput.jsp',
      yamato_tracking_url: 'https://toi.kuronekoyamato.co.jp/cgi-bin/tneko',
      shop_name: emailConfig.value?.senderName,
      order_no: '#001'
    },
    items: [
      {
        sku: 'SKU-001',
        item_code: 'ITEM-001',
        item_attribute: 'XL',
        item_name: 'テスト商品A',
        item_sub_name: 'テスト商品A_sub',
        item_quantity: 2,
        shop_sku: 'SKU-001'
      },
      {
        sku: 'SKU-002',
        item_code: 'ITEM-002',
        item_attribute: 'M',
        item_name: 'テスト商品B',
        item_sub_name: 'テスト商品B_sub',
        item_quantity: 1,
        shop_sku: 'SKU-002'
      }
    ] as unknown as ShopEmailTemplateReqDTO['items']
  }
  return payload
}

/** 从预览接口响应中读取渲染后的邮件正文。 */
function getTemplatePreviewContent(data?: ShopEmailTemplatePreviewRespDTO) {
  /** 模板预览接口响应数据。 */
  const responseData = data || {}
  /** 后端实际响应中可能返回的预览正文字段。 */
  const previewContent = Reflect.get(responseData, 'previewContent')
  /** 生成接口类型中标注的渲染后正文字段。 */
  const content = previewContent || responseData.content || ''
  return ensureHtml(String(content))
}

/** 校验测试收件人并发送测试邮件。 */
async function sendTestMail() {
  /** 测试发送表单校验结果。 */
  const valid = await testFormRef.value?.validate?.().catch(() => false)
  if (!valid) return
  const template = form.templateList.find(item => stringifyId(item.id) === testForm.templateId) || form.templateList[0]
  if (!template) {
    ElMessage.warning(t('メールテンプレートがありません'))
    return
  }
  testSendLoading.value = true
  try {
    const res = await request.customer.aws.shopEmailSend({
      ...getShopPayload(),
      recipientEmail: testForm.to,
      sourceType: 'MANUAL',
      subject: testForm.subject,
      content: testForm.body
    })
    if (!res?.success) return
    testDialogVisible.value = false
    ElMessage.success(t('テストメールを送信しました'))
  } finally {
    testSendLoading.value = false
  }
}

/** 保存发件人、自动发送和默认模板等邮件配信设置。 */
async function saveSettings() {
  if (!form.senderName.trim()) {
    ElMessage.error(t('名前を入力してください'))
    return
  }
  if (!isEmail(form.senderEmail)) {
    ElMessage.error(t('メールアドレスを入力してください'))
    return
  }
  /** 当前认证方式下允许保存的邮箱集合。 */
  const allowedSenderEmails = getAllowedSenderEmailsByAuthType(emailConfig.value, form.authType)
  if (allowedSenderEmails.length && !allowedSenderEmails.includes(form.senderEmail)) {
    ElMessage.error(t('メールアドレスが変更されました。再認証後に保存してください。'))
    return
  }
  if (form.authType === AUTH_TYPE.DOMAIN && !domainDnsRecordList.value.length && normalizedAuthStatus.value !== 2) {
    ElMessage.error(t('ドメイン認証情報を取得してください'))
    return
  }

  submitLoading.value = true
  try {
    /** 邮件配信设置保存接口入参。 */
    const payload = {
      ...getShopPayload(),
      senderName: form.senderName,
      senderEmail: form.senderEmail,
      identityType: form.authType,
      emailAutoSendEnabled: form.autoSend ? 1 : 0,
      normalTemplateId: numberId(form.defaultTemplateIds.NORMAL),
      partialTemplateId: numberId(form.defaultTemplateIds.PARTIAL),
      finalTemplateId: numberId(form.defaultTemplateIds.FINAL)
    }
    await request.customer.aws.shopEmailSettingAutoSendUpdate(payload)
    ElMessage.success(t('メール配信設定を保存しました'))
    loadSettings()
  } finally {
    submitLoading.value = false
  }
}

/** 校验邮箱地址格式。 */
function isEmail(email: string) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
}

/** 将接口或本地 ID 统一转换为字符串。 */
function stringifyId(id: any) {
  return id === undefined || id === null || id === '' ? '' : String(id)
}

/** 将字符串 ID 转换为接口需要的数字 ID。 */
function numberId(id: string) {
  return id ? Number(id) : undefined
}

/** 获取邮件模板场景展示标题。 */
function getTemplateSceneTitle(templateScene?: string) {
  return sceneMap[templateScene || 'NORMAL']?.shortTitle || sceneMap.NORMAL.shortTitle
}

/** 确保模板正文内容是 HTML 格式。 */
function ensureHtml(value: string) {
  if (!value) return ''
  return /<\/?[a-z][\s\S]*>/i.test(value) ? value : plainToHtml(value)
}

/** 从富文本 HTML 中提取用于必填校验的纯文本内容。 */
function getPlainText(value: string) {
  return String(value || '')
    .replace(/<style[\s\S]*?<\/style>/gi, '')
    .replace(/<script[\s\S]*?<\/script>/gi, '')
    .replace(/<[^>]+>/g, '')
    .replace(/&nbsp;/g, ' ')
    .replace(/\s+/g, '')
}

/** 将纯文本正文转换为 Quill 可编辑的段落 HTML。 */
function plainToHtml(value: string) {
  return value
    .split(/\n{2,}/)
    .map(block => `<p>${escapeHtml(block).replace(/\n/g, '<br>')}</p>`)
    .join('')
}

/** 将变量占位符追加到 HTML 正文最后一个段落内。 */
function appendVariable(content: string, value: string) {
  /** 标准化后的正文 HTML。 */
  const body = ensureHtml(content || '<p></p>')
  if (body.includes('</p>')) {
    return body.replace(/<\/p>(?![\s\S]*<\/p>)/, `${value}</p>`)
  }
  return `${body}<p>${value}</p>`
}

/** 转义纯文本中的 HTML 特殊字符。 */
function escapeHtml(value: string) {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}


return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('出荷完了後、設定したテンプレートを利用してお客様へメールを自動送信します。')), 1)
        ]),
        (_unref(showTestSend))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "default",
              onClick: openTestDialog
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Message))
                  ]),
                  _: 1
                }),
                _createTextVNode(" " + _toDisplayString(_unref(t)('テスト送信')), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('メール送信者')), 1),
        _createVNode(_component_el_form, {
          "label-width": "150px",
          "label-position": "left"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _unref(t)('名前'),
              class: "form-item-required"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  style: {"width":"400px"},
                  modelValue: _unref(form).senderName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).senderName) = $event)),
                  maxlength: "80"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('メールアドレス'),
              class: "form-item-required"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_el_input, {
                    style: {"width":"400px"},
                    modelValue: _unref(form).senderEmail,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).senderEmail) = $event)),
                    modelModifiers: { trim: true },
                    disabled: _unref(senderEmailDisabled),
                    onInput: handleSenderEmailInput
                  }, null, 8, ["modelValue", "disabled"]),
                  (_unref(senderEmailDisabled))
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        style: {"margin-left":"10px"},
                        type: "default",
                        onClick: startSenderEmailEdit
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('変更')), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('認証方式')
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_el_radio_group, {
                    modelValue: _unref(form).authType,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).authType) = $event)),
                    onChange: handleAuthTypeChange
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio, {
                        label: _unref(AUTH_TYPE).EMAIL
                      }, {
                        default: _withCtx(() => [
                          _hoisted_9
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_el_radio, {
                        label: _unref(AUTH_TYPE).DOMAIN
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('ドメイン認証')), 1)
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  (_unref(form).authType === _unref(AUTH_TYPE).EMAIL)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(t)('ご入力いただいたメールアドレス宛に認証メールを送信します。メールに記載されたURLをクリックし、認証を完了してください。')), 1),
                        (_unref(activeEmailAuthEmail))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                              _createElementVNode("span", null, _toDisplayString(_unref(t)('メールアドレスの変更には再認証が必要です。')), 1),
                              _createElementVNode("b", null, _toDisplayString(_unref(activeEmailAuthEmail)), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_unref(showReAuthNotice))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                              _createElementVNode("b", null, _toDisplayString(_unref(t)('メールアドレスの変更には再認証が必要です。')), 1),
                              _createElementVNode("span", null, _toDisplayString(_unref(t)('新しいメールアドレスの認証が完了するまでは、現在の認証済みメールアドレスが使用されます。')), 1)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_14, [
                          (_unref(showSendAuth))
                            ? (_openBlock(), _createBlock(_component_el_button, {
                                key: 0,
                                disabled: !_unref(canStartSmtpAuth),
                                loading: authSendingLoading.value,
                                type: "default",
                                onClick: startSmtpAuth
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(t)('認証メールを送信')), 1)
                                ]),
                                _: 1
                              }, 8, ["disabled", "loading"]))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", {
                            class: _normalizeClass(['auth-status', _unref(isVerifiedSender) ? 'is-ok' : 'is-pending'])
                          }, [
                            (_unref(isVerifiedSender))
                              ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(CircleCheck))
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createTextVNode(" " + _toDisplayString(_unref(authStatusText)), 1)
                          ], 2)
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(t)('「取得」をクリックすると、ドメイン認証用の認証リンクが生成されます。')), 1),
                        _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(t)('リンクをコピーしてサーバー管理者へ共有してください。DNS設定完了後、認証状態が更新されます。')), 1),
                        (_unref(activeDomainAuthEmail))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                              _createElementVNode("span", null, _toDisplayString(_unref(t)('現在有効なドメイン認証メールアドレス')), 1),
                              _createElementVNode("b", null, _toDisplayString(_unref(activeDomainAuthEmail)), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_unref(domainAuthMessage))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                              _createElementVNode("span", null, _toDisplayString(_unref(domainAuthMessage)), 1)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_20, [
                          (_unref(showStartDomainAuth))
                            ? (_openBlock(), _createBlock(_component_el_button, {
                                key: 0,
                                disabled: !_unref(canStartDomainAuth),
                                loading: authSendingLoading.value,
                                type: "default",
                                onClick: startDomainAuth
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(t)('取得')), 1)
                                ]),
                                _: 1
                              }, 8, ["disabled", "loading"]))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", {
                            class: _normalizeClass(['auth-status', _unref(isVerifiedSender) ? 'is-ok' : 'is-pending'])
                          }, [
                            (_unref(isVerifiedSender))
                              ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(CircleCheck))
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createTextVNode(" " + _toDisplayString(_unref(authStatusText)), 1)
                          ], 2)
                        ]),
                        (domainDnsRecordList.value.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                              _createElementVNode("div", _hoisted_22, [
                                _createElementVNode("span", null, _toDisplayString(_unref(t)('種別')), 1),
                                _createElementVNode("span", null, _toDisplayString(_unref(t)('ホスト名')), 1),
                                _createElementVNode("span", null, _toDisplayString(_unref(t)('値')), 1)
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(domainDnsRecordList.value, (record, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "dns-records__row",
                                  key: `${record.type}-${record.name}-${index}`
                                }, [
                                  _createElementVNode("span", null, _toDisplayString(record.type || '-'), 1),
                                  _createElementVNode("span", _hoisted_23, [
                                    _createElementVNode("span", null, _toDisplayString(record.name || '-'), 1),
                                    (record.name)
                                      ? (_openBlock(), _createBlock(_component_el_icon, {
                                          key: 0,
                                          class: "dns-records__copy",
                                          onClick: _withModifiers(($event: any) => (copyDnsField(record.name)), ["stop"])
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(DocumentCopy))
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("span", _hoisted_24, [
                                    _createElementVNode("span", null, _toDisplayString(record.value || '-'), 1),
                                    (record.value)
                                      ? (_openBlock(), _createBlock(_component_el_icon, {
                                          key: 0,
                                          class: "dns-records__copy",
                                          onClick: _withModifiers(($event: any) => (copyDnsField(record.value)), ["stop"])
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(DocumentCopy))
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                ])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('自動送信')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_switch, {
                  modelValue: _unref(form).autoSend,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(form).autoSend) = $event))
                }, null, 8, ["modelValue"]),
                _createElementVNode("span", _hoisted_25, _toDisplayString(_unref(t)('出荷完了時に自動送信する')), 1)
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_26, [
      _createVNode(_component_el_button, {
        type: "primary",
        size: "large",
        loading: submitLoading.value,
        onClick: saveSettings
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('保存')), 1)
        ]),
        _: 1
      }, 8, ["loading"])
    ]),
    (_unref(form).templateList.length)
      ? (_openBlock(), _createElementBlock("section", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_29, _toDisplayString(_unref(t)('自動送信メール')), 1),
              _createElementVNode("div", _hoisted_30, _toDisplayString(_unref(t)('利用するメールテンプレートを選択します。')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_31, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(sceneOptions, (scene) => {
              return _createElementVNode("div", {
                class: "template-row",
                key: scene.value
              }, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, _toDisplayString(_unref(t)(scene.title)), 1),
                  _createElementVNode("div", _hoisted_34, _toDisplayString(_unref(t)(scene.desc)), 1)
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, _toDisplayString(_unref(t)('メールテンプレート')), 1),
                  _createElementVNode("div", _hoisted_37, [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(form).defaultTemplateIds[scene.value],
                      "onUpdate:modelValue": ($event: any) => ((_unref(form).defaultTemplateIds[scene.value]) = $event)
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(templatesByScene(scene.value), (template) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: template.id,
                            label: template.templateName,
                            value: stringifyId(template.id)
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue"]),
                    _createVNode(_component_el_button, {
                      class: "icon-btn",
                      type: "default",
                      loading: templateDetailLoading.value,
                      disabled: templateDetailLoading.value || !_unref(form).defaultTemplateIds[scene.value],
                      onClick: ($event: any) => (openSelectedTemplate(scene.value))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(View))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["loading", "disabled", "onClick"])
                  ])
                ])
              ])
            }), 64))
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_drawer, {
      modelValue: templateDrawerVisible.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((templateDrawerVisible).value = $event)),
      title: _unref(t)('テンプレート確認・編集'),
      size: "50%",
      "append-to-body": "",
      "custom-class": "email-template-drawer"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_41, [
          _createVNode(_component_el_button, {
            onClick: _cache[8] || (_cache[8] = ($event: any) => (templateDrawerVisible.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('キャンセル')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "default",
            loading: templatePreviewLoading.value,
            onClick: previewCurrentTemplate
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('プレビュー')), 1)
            ]),
            _: 1
          }, 8, ["loading"]),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: saveTemplate,
            loading: confirmLoading.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('保存')), 1)
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          class: "template-form",
          "label-width": "140px",
          "label-position": "left",
          model: _unref(templateForm),
          rules: rules.value,
          ref: (_value, _refs) => {
            _refs['templateFormRef'] = _value
            templateFormRef.value = _value
          }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _unref(t)('テンプレート名'),
              prop: "templateName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(templateForm).templateName,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(templateForm).templateName) = $event)),
                  maxlength: "120"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('テンプレート'),
              prop: "templateScene"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(templateForm).templateScene,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(templateForm).templateScene) = $event)),
                  onChange: handleTemplateSceneChange,
                  disabled: !!editingTemplateId.value
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(sceneOptions, (scene) => {
                      return _createVNode(_component_el_option, {
                        key: scene.value,
                        label: _unref(t)(scene.shortTitle),
                        value: scene.value
                      }, null, 8, ["label", "value"])
                    }), 64))
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('件名'),
              prop: "subject"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(templateForm).subject,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(templateForm).subject) = $event)),
                  maxlength: "160"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('本文'),
              class: "rich-editor-item",
              prop: "content"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_38, [
                  _createVNode(_unref(QuillEditor), {
                    ref: (_value, _refs) => {
                      _refs['templateEditorRef'] = _value
                      templateEditorRef.value = _value
                    },
                    content: _unref(templateForm).content,
                    "onUpdate:content": _cache[7] || (_cache[7] = ($event: any) => ((_unref(templateForm).content) = $event)),
                    class: "rich-editor",
                    "content-type": "html",
                    theme: "snow",
                    toolbar: toolbarOptions
                  }, null, 8, ["content"])
                ])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["model", "rules"]),
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("div", _hoisted_40, _toDisplayString(_unref(t)('差し込み項目')), 1),
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(variableOptions, (item) => {
            return _createVNode(_component_el_button, {
              key: item.value,
              type: "default",
              size: "small",
              onClick: ($event: any) => (insertVariable(item.value))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)(item.label)), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])
          }), 64))
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: templatePreviewVisible.value,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((templatePreviewVisible).value = $event)),
      title: "メールプレビュー",
      width: "700px",
      "append-to-body": "",
      "custom-class": "email-preview-dialog"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[10] || (_cache[10] = ($event: any) => (templatePreviewVisible.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('閉じる')), 1)
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_42, [
          _createElementVNode("div", _hoisted_43, [
            _hoisted_44,
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, _toDisplayString(_unref(t)('件名')) + "：" + _toDisplayString(_unref(templatePreviewData).subject), 1),
              _createElementVNode("pre", {
                class: "mail-preview__body",
                innerHTML: _unref(templatePreviewData).previewContent
              }, null, 8, _hoisted_47)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_drawer, {
      modelValue: testDialogVisible.value,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((testDialogVisible).value = $event)),
      title: _unref(t)('テスト送信'),
      size: "50%",
      "append-to-body": "",
      "custom-class": "email-test-drawer"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_49, [
          _createVNode(_component_el_button, {
            onClick: _cache[16] || (_cache[16] = ($event: any) => (testDialogVisible.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('キャンセル')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            loading: testSendLoading.value,
            onClick: sendTestMail
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('送信')), 1)
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ]),
      default: _withCtx(() => [
        _withDirectives(_createVNode(_component_el_form, {
          class: "test-form",
          "label-width": "130px",
          "label-position": "left",
          model: _unref(testForm),
          rules: testRules.value,
          ref: (_value, _refs) => {
            _refs['testFormRef'] = _value
            testFormRef.value = _value
          }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _unref(t)('宛先'),
              prop: "to",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(testForm).to,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(testForm).to) = $event)),
                  modelModifiers: { trim: true }
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('テンプレート'),
              prop: "templateId",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(testForm).templateId,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(testForm).templateId) = $event)),
                  onChange: syncTestTemplate
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(form).templateList, (template) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: template.id,
                        label: `${template.templateName}`,
                        value: stringifyId(template.id)
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('件名'),
              prop: "subject",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(testForm).subject,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(testForm).subject) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('本文'),
              class: "rich-editor-item",
              prop: "body",
              required: ""
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_48, [
                  _createVNode(_unref(QuillEditor), {
                    content: _unref(testForm).body,
                    "onUpdate:content": _cache[15] || (_cache[15] = ($event: any) => ((_unref(testForm).body) = $event)),
                    class: "rich-editor",
                    "content-type": "html",
                    theme: "snow",
                    toolbar: toolbarOptions
                  }, null, 8, ["content"])
                ])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["model", "rules"]), [
          [_directive_loading, testPreviewLoading.value]
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 512)), [
    [_directive_loading, initLoading.value]
  ])
}
}

})